// 全部api
import http from '@/api/httpClient'

// post请求
const POST = function (url, params) {
  return new Promise((resolve, reject) => {
    http
      .post(url, params)
      .then((res) => {
        resolve(res.data)
      })
      .catch((err) => {
        reject(err)
      })
  })
}
// get请求
const GET = function (url, params) {
  return new Promise((resolve, reject) => {
    http
      .get(url, {
        params: params
      })
      .then((res) => {
        resolve(res.data)
      })
      .catch((err) => {
        reject(err)
      })
  })
}
// 用户登录
const userLogin = function (data) {
  return http.post('/auth/OPWebAppLogin', data)
}
// 获取船舶AIS信息
const obtainAISInfo = async function (data) {
  try {
    const res = await http.post('/GetAISDataAPI', data)
    return new Promise((resolve) => {
      resolve(res.data)
    })
  } catch (err) {
    console.log(err)
  }
}
// 注册验证，检查邮箱是否重复
const checkEmailName = async function (data) {
  try {
    const res = await http.get('/auth/OPUserEmailCheck', data)
    return new Promise((resolve) => {
      resolve(res.data)
    })
  } catch (err) {
    console.log(err)
  }
}
// 注册验证，检查昵称是否重复
const checkOperName = async function (data) {
  try {
    const res = await http.get('/auth/OPUserOperNameCheck', data)
    return new Promise((resolve) => {
      resolve(res.data)
    })
  } catch (err) {
    console.log(err)
  }
}
// 注册验证，检查公司名是否重复
const checkCompanyName = async function (data) {
  try {
    const res = await http.get('/auth/OPCheckCorpName', data)
    return new Promise((resolve) => {
      resolve(res.data)
    })
  } catch (err) {
    console.log(err)
  }
}
// 新用户注册
const userRegist = async function (data) {
  try {
    const res = await http.post('/auth/OPNewRegister', data)
    return new Promise((resolve) => {
      resolve(res.data)
    })
  } catch (err) {
    console.log(err)
  }
}
// 发送邮箱激活链接
const sendVerifyEmail = async function (data) {
  try {
    const res = await http.get('/auth/OPSendVerifyEmail', data)
    return new Promise((resolve) => {
      resolve(res.data)
    })
  } catch (err) {
    console.log(err)
  }
}
// 个人信息完善
const completeUserInfo = async function (data) {
  try {
    const res = await http.get('/auth/OPUserCompleteInfo', data)
    return new Promise((resolve) => {
      resolve(res.data)
    })
  } catch (err) {
    console.log(err)
  }
}
// 忘记密码
const forgetPassword = async function (data) {
  try {
    const res = await http.get('/auth/OPForgotPassword', data)
    return new Promise((resolve) => {
      resolve(res.data)
    })
  } catch (err) {
    console.log(err)
  }
}
// 查询船舶数量
const selectShipNum = async function (data) {
  try {
    const res = await http.post('/SIShipInfoQryCount', data)
    return new Promise((resolve) => {
      resolve(res.data)
    })
  } catch (err) {
    console.log(err)
  }
}
// 添加船舶
const addShip = async function (data) {
  return http.post('/SIShipInfoAdd', data)
}
// 修改船舶
const updateShipInfo = async function (data) {
  return http.post('/SIShipInfoMod', data)
}
// 删除船舶
const removeShip = async function (data) {
  return http.post('/SIShipInfoDel', data)
}
// 删除预算记录
const deleteBudgetRecord = async function (data) {
  return http.post('/ATVoyageEstiDel', data)
}
// 添加修改预算记录
const addBudgetRecord = async function (data) {
  return http.post('/ATEstiMod4Mobile', data)
}

export { POST, GET, userLogin, deleteBudgetRecord, addBudgetRecord, addShip, updateShipInfo, removeShip }
